import  { useEffect, useMemo, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React from "react";

gsap.registerPlugin(ScrollTrigger);

// const wrapWithWordSpans = (node, keyPrefix = "") => {
//   if (typeof node === "string") {
//     return node.split(/(\s+)/).map((word, index) => (
//       <span
//         className="word"
//         key={`${keyPrefix}-${index}`}
//         style={{ display: 'inline-block', whiteSpace: 'pre' }}
//       >
//         {word === " " ? "\u00A0" : word}
//       </span>
//     ));
//   }
//   if (Array.isArray(node)) {
//     return node.flatMap((child, index) =>
//       wrapWithWordSpans(child, `${keyPrefix}-${index}`)
//     );
//   }
//   if (typeof node === "object" && node !== null && node.type) {
//     return (
//       <node.type {...node.props} key={keyPrefix}>
//         {wrapWithWordSpans(node.props.children, keyPrefix)}
//       </node.type>
//     );
//   }
//   return null;
// };
const wrapWithWordSpans = (node, keyPrefix) => {
  if (typeof node === "string") {
    // Splits by spaces but keeps them in the array
    return node.split(/(\s+)/).map((word, index) => {
      const isWhitespace = /^\s+$/.test(word);
      const uniqueKey = `${keyPrefix}-${index}`;

      if (isWhitespace) {
        // Render raw whitespace to preserve original spacing naturally
        return <React.Fragment key={uniqueKey}>{word}</React.Fragment>;
      }

      return (
        <span
          className="word"
          key={uniqueKey}
          style={{ display: "inline-block", whiteSpace: "pre" }}
        >
          {word}
        </span>
      );
    });
  }
  if (Array.isArray(node)) {
    return node.flatMap((child, index) =>
      wrapWithWordSpans(child, `${keyPrefix}-${index}`),
    );
  }
  if (typeof node === "object" && node !== null && node.type) {
    return (
      <node.type {...node.props} key={keyPrefix}>
        {wrapWithWordSpans(node.props.children, keyPrefix)}
      </node.type>
    );
  }
  return null;
};

const ScrollFloat = ({
  children,
  scrollContainerRef,
  containerClassName = "",
  textClassName = "",
  animationDuration = 1.5,
  ease = "power2.out",
  scrollStart = "top bottom+=50%",
  scrollEnd = "bottom bottom-=30%",
  stagger = 0.08,
  scrub = 1.2,
  yOffset = 120,
  rotateX = -20,
}) => {
  const containerRef = useRef(null);

  const splitText = useMemo(() => {
    return wrapWithWordSpans(children, "word");
  }, [children]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const scroller =
      scrollContainerRef && scrollContainerRef.current
        ? scrollContainerRef.current
        : window;

    const ctx = gsap.context(() => {
      const wordElements = el.querySelectorAll(".word");

      gsap.fromTo(
        wordElements,
        {
          willChange: "opacity, transform",
          opacity: 0,
          y: yOffset,
          rotateX: rotateX,
          transformOrigin: "50% 0%",
        },
        {
          duration: animationDuration,
          ease: ease,
          opacity: 1,
          y: 0,
          rotateX: 0,
          stagger: stagger,
          scrollTrigger: {
            trigger: el,
            scroller,
            start: scrollStart,
            end: scrollEnd,
            scrub: scrub,
          },
        },
      );
    }, el);

    return () => ctx.revert();
  }, [
    scrollContainerRef,
    animationDuration,
    ease,
    scrollStart,
    scrollEnd,
    stagger,
    scrub,
    yOffset,
    rotateX,
  ]);

  return (
    <h2
      ref={containerRef}
      className={`scroll-float text-center ${containerClassName}`}
      style={{
        perspective: "800px",
        transformStyle: "preserve-3d",
        overflow: "hidden",
      }}
    >
      <span
        className={`scroll-float-text ${textClassName}`}
        style={{ display: "inline-block" }}
      >
        {splitText}
      </span>
    </h2>
  );
};

export default ScrollFloat;
